module.exports = __webpack_public_path__ + "img/a14dbc157709e5b6426a1525e0f52d17.png";